import angular from 'angular';

// TODO nella parte web gli import di Cordova falliscono. Serve qualche logica in piu' per evitare errori
const docServiceFactory = function docServiceFactory($window, $log) {
        "ngInject";
  return {

    /**
     * showDoc - Mostra un documento pdf ottenuto dinamicamente da backend
     *
     * @param  {string} url
     * @param  {boolean} isImage
     */
    showDoc: (url, isImage) => {
      const type = isImage ? 'image' : 'pdf';
      $log.debug(`docService: Opening ${type} file ${url}`);
      const docPage = $window.open(url, '_blank');
      docPage.opener = null;
    }
  };
};

// const serviceModule = angular.module('tinaba.framework.services.docService', []).factory('docService', function($rootScope, $q, $cordovaDevice, $cordovaInAppBrowser, $log) {
//   return {
//
//     /**
//      * showDoc - Mostra un documento pdf ottenuto dinamicamente da backend
//      *
//      * @param  {string} url
//      */
//     showDoc: (url) => {
//
//       if (!window.cordova) {
//         window.open(url, '_blank');
//       } else if ($cordovaDevice.getPlatform().toLowerCase() === "android") {
//         // window.location = url;
//         const
//           target = "_system",
//           options = {
//             location: 'no',
//             clearcache: 'yes',
//             toolbar: 'no'
//           };
//         $cordovaInAppBrowser.open(url, target, options)
//           .then(function(event) {
//             $log.debug(`${event}`);
//           })
//           .catch(function(event) {
//             $log.error(`${event}`);
//           });
//
//       } else {
//         // ios
//         const
//           target = "_system",
//           options = {
//             location: 'no',
//             clearcache: 'yes',
//             toolbar: 'no'
//           };
//         $cordovaInAppBrowser.open(url, target, options)
//           .then(function(event) {
//             $log.debug(event);
//           })
//           .catch(function(event) {
//             $log.error(event);
//           });
//       }
//     }
//   };
// });



export default docServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/doc.factory.js
 **/